import { handleApiCall } from "../Helpers/HandleApi";
import {
  getJHHRequestTokenPath,
  getJHHSendRegistrationOTPPath,
  getJHHRefreshTokenPath,
  getJHHRefreshTokenAckPath,
  getJHHRegisterDevicePath,
  getJHHRequestAccessPath,
  getJHHResendRegistrationOTPPath,
  getJHHSendFamilyAssociationOTPPath,
  getVerifyAssociationOTPPath,
  getJHHUpdateProfileDetailsPath,
} from "../../Constants/config";

export const _getRequestTokenResponse = (dataObj: {}, customUrl?: string) => {
  return handleApiCall({
    url: customUrl? customUrl : getJHHRequestTokenPath,
    method: "post",
    dataObj: dataObj,
    headers:{"Content-Type": "application/x-www-form-urlencoded"},
    requestBody: { type: Object, encryption: false,queryString:true },
  },
  );
};

export const _getRefreshTokenResponse = (dataObj: {}) => {
  return handleApiCall(
    {
      url: getJHHRefreshTokenPath,
      method: "post",
      dataObj: dataObj,
      headers:{"Content-Type": "application/x-www-form-urlencoded"},
      requestBody: { type: Object, encryption: true,queryString:true },
    },
    true,
    true,
    true
  );
};

export const _getRefreshTokenAckResponse = (dataObj: {}) => {
  return handleApiCall(
    {
      url: getJHHRefreshTokenAckPath,
      method: "post",
      dataObj: dataObj,
      headers:{"Content-Type": "application/x-www-form-urlencoded"},
      requestBody: { type: Object, encryption: true,queryString:true },
    },
    true,
    true,
    true
  );
};

export const _getJHHSendRegistrationOTPResponse = (
  dataObj: {},
  redirectURL?: string
) => {
  return handleApiCall(
    {
      url: getJHHSendRegistrationOTPPath,
      method: "post",
      dataObj: dataObj,
      headers:{"Content-Type": "application/x-www-form-urlencoded"},
      requestBody: { type: Object, encryption: true,queryString:true },
      responseBody: { decryption: true },
      redirectURL: redirectURL,
    },
    true
  );
};

export const _getJHHSendFamilyAssociationOTPResponse = (
  dataObj: {},
  redirectURL?: string
) => {
  return handleApiCall(
    {
      url: getJHHSendFamilyAssociationOTPPath,
      method: "post",
      dataObj: dataObj,
      headers:{"Content-Type": "application/x-www-form-urlencoded"},
      requestBody: { type: Object, encryption: true,queryString:true },
      responseBody: { decryption: true },
      redirectURL: redirectURL,
    },
    true,
    true
  );
};

export const _getJHHResendRegistrationOTPResponse = (dataObj: {}) => {
  return handleApiCall(
    {
      url: getJHHResendRegistrationOTPPath,
      method: "post",
      dataObj: dataObj,
      headers:{"Content-Type": "application/x-www-form-urlencoded"},
      requestBody: { type: Object, encryption: true,queryString:true },
      responseBody: { decryption: true },
    },
    true
  );
};

export const _getRequestAccessResponse = (dataObj: {}) => {
  return handleApiCall(
    {
      url: getJHHRequestAccessPath,
      method: "post",
      dataObj: dataObj,
      headers:{"Content-Type": "application/x-www-form-urlencoded"},
      requestBody: { type: Object, encryption: true,queryString:true },
      responseBody: { decryption: true },
      setJHHUserInfo: true,
    },
    true
  );
};

export const _getVerifyAssociationOTPResponse = (dataObj: {}) => {
  return handleApiCall(
    {
      url: getVerifyAssociationOTPPath,
      method: "post",
      dataObj: dataObj,
      headers:{"Content-Type": "application/x-www-form-urlencoded"},
      requestBody: { type: Object, encryption: true,queryString:true },
      responseBody: { decryption: true },
    },
    true,
    true
  );
};

export const _getRegisterDeviceResponse = (
  dataObj: {},
  setJHHDeviceInfo = true
) => {
  return handleApiCall(
    {
      url: getJHHRegisterDevicePath,
      method: "post",
      dataObj: dataObj,
      headers:{"Content-Type": "application/x-www-form-urlencoded"},
      requestBody: { type: Object, encryption: true,queryString:true },
      responseBody: { decryption: true },
      setJHHDeviceInfo: setJHHDeviceInfo,
    },
    true
  );
};

export const _registerUserJhhApiCall = (dataObj: {}) => {
  return handleApiCall(
    {
      url: getJHHUpdateProfileDetailsPath,
      method: "post",
      dataObj: dataObj,
      headers:{"Content-Type": "application/x-www-form-urlencoded"},
      requestBody: { type: Object, encryption: true,queryString:true },
    },
    true
  );
};
